
        import type { TemplateResult, TemplateRootPropsForTag } from 'Components/types';
type relatedItemsRTRootProps = TemplateRootPropsForTag<'div'>;
import { createElement as _createElement } from 'preact';
import { map as _map } from 'Utils/array';
import _translate from 'Utils/translate';
export default function relatedItemsRT(): TemplateResult<relatedItemsRTRootProps> {
    function repeatItems1(items, itemsIndex) {
        return [items(function () {
                function repeatI1(i, iIndex) {
                    return _createElement('span', {
                        'key': i,
                        'className': 'cm_star cm_star__' + (!(this.review_average - i) || this.review_average - i < 0.25 ? 'empty' : this.review_average - i < 0.75 ? 'half' : 'full')
                    });
                }
                function scopeProductId2() {
                    var productId = this.variant_ids && this.variant_ids.length ? this.variant_ids[0] : this.id;
                    return _createElement('form', {
                        'method': 'post',
                        'action': '/cart/add',
                        'id': 'product_form_' + this.id,
                        'accept-charset': 'UTF-8',
                        'encType': 'multipart/form-data',
                        'noValidate': 'novalidate',
                        'data-product-handle': this.handle,
                        'data-current-product-id': productId
                    }, _createElement('input', {
                        'type': 'hidden',
                        'name': 'product-id',
                        'value': this.id
                    }), _createElement('div', { 'className': 'product-item__quick-add-button-wrapper' }, this.variant_ids.length > 1 ? [_createElement('a', {
                            'className': 'product-item__quick-add-button btn btn--medium-small btn--primary btn--full',
                            'href': this.url,
                            'aria-label': 'button',
                            'key': '28281'
                        }, '\n              ', this.out_of_stock ? _translate(`product_out_of_stock`) : _translate(`product_select_options`), '\n            ')] : null, this.variant_ids.length === 1 ? [
                        _createElement('div', {
                            'className': 'product-item__quick-add-qty-selector',
                            'key': '31811'
                        }, _createElement('button', {
                            'type': 'button',
                            'disabled': this.out_of_stock,
                            'className': 'product-item__quick-add-qty-button product-item__quick-add-qty-button--minus',
                            'data-quick-add-quantity': true,
                            'data-change': 'decrement'
                        }, [_createElement('span', {
                                'className': 'icon',
                                'key': '35150'
                            }, _createElement('svg', {
                                'width': '100%',
                                'viewBox': '0 0 24 24'
                            }, _createElement('path', {
                                'fill': 'none',
                                'stroke': 'currentColor',
                                'strokeWidth': '1',
                                'strokeLinecap': 'round',
                                'strokeLinejoin': 'round',
                                'd': 'M5 12h14'
                            })))]), _createElement('input', {
                            'type': 'number',
                            'data-quantity-input': true,
                            'value': this.set_qty || 1,
                            'min': '1',
                            'pattern': '[0-9]*',
                            'aria-label': 'Quantity'
                        }), _createElement('button', {
                            'type': 'button',
                            'disabled': this.out_of_stock,
                            'className': 'product-item__quick-add-qty-button product-item__quick-add-qty-button--plus',
                            'data-quick-add-quantity': true,
                            'data-change': 'increment',
                            'aria-label': 'Add product quantity'
                        }, [_createElement('span', {
                                'className': 'icon',
                                'key': '41510'
                            }, _createElement('svg', {
                                'width': '100%',
                                'viewBox': '0 0 24 24'
                            }, _createElement('path', {
                                'fill': 'none',
                                'stroke': 'currentColor',
                                'strokeWidth': '1',
                                'strokeLinecap': 'round',
                                'strokeLinejoin': 'round',
                                'd': 'M12 5v14M5 12h14'
                            })))])),
                        _createElement('button', {
                            'data-quick-add': this.handle,
                            'data-product-id': productId,
                            'type': 'button',
                            'disabled': this.out_of_stock,
                            'className': 'product-item__quick-add-button btn btn--medium-small btn--primary btn--full',
                            'data-open-quick-cart': 'true',
                            'key': '31813'
                        }, _createElement('span', { 'className': 'product-item__quick-add-button-text' }, '\n                ', this.out_of_stock ? _translate(`product_out_of_stock`) : _translate(`product_add_to_cart`), '\n              '), _createElement('span', { 'className': 'product-item__quick-add-button-text-height' }, 'x'), _createElement('span', { 'className': 'icon product-item__quick-add-button-icon' }, [_createElement('svg', {
                                'width': '100%',
                                'viewBox': '0 0 24 24',
                                'key': '50290'
                            }, _createElement('path', {
                                'fill': 'none',
                                'stroke': 'currentColor',
                                'strokeWidth': '1',
                                'strokeLinecap': 'round',
                                'strokeLinejoin': 'round',
                                'd': 'M12 5v14M5 12h14'
                            }))]), _createElement('span', { 'className': 'icon product-item__quick-add-button-check' }, [_createElement('svg', {
                                'width': '100%',
                                'viewBox': '0 0 24 24',
                                'key': '53360'
                            }, _createElement('path', {
                                'fill': 'currentColor',
                                'd': 'M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z'
                            }))]))
                    ] : null));
                }
                return _createElement('div', { 'className': 'product-item product-item--square product-item--has-quick-add' }, _createElement('div', { 'className': 'product-item__inner' }, _createElement('div', { 'className': 'product-item__media' }, _createElement('a', {
                    'className': 'product-item__image-link',
                    'href': this.url
                }, _createElement('div', { 'className': 'image js-enabled image--style-disabled product-item__image' }, _createElement('img', {
                    'className': 'image__img lazyautosizes lazyloaded',
                    'src': this.imageOrDefault(this.resizeImage(this.image)),
                    'alt': this.removeHTML(this.title),
                    'onError': this.onImageError
                })))), _createElement('div', { 'className': 'product-item__meta fs-body-small' }, _createElement('div', { 'className': 'product-item__text ff-body fs-body-base ta-c' }, _createElement('h4', { 'className': 'product-item__product-title fs-product-title fs-body-bold' }, _createElement('a', Object.assign({}, { 'href': this.url }, { dangerouslySetInnerHTML: { __html: typeof this.title === 'undefined' ? '' : this.title } }))), _createElement('div', { 'className': 'product-item__price-wrap' }, _createElement('p', { 'className': 'product-item__price ff-product-price' }, _createElement('span', { 'className': 'product-item__price-main' }, _createElement('span', { 'className': 'visually-hidden' }, 'Regular price'), this.on_sale ? _createElement('s', {
                    'className': 't-subdued',
                    'key': '1119'
                }, this.formatPrice(this.compare_at_price)) : null, _createElement('span', { 'className': this.on_sale ? 'sale' : '' }, this.formatPrice(this.price))), this.on_sale ? _createElement('span', {
                    'className': 'displayed-discount-wrapper',
                    'key': '1354'
                }, _createElement('span', {
                    'className': 'displayed-discount badge-shape fs-body-60',
                    'data-badge-shape': 'rectangle'
                }, '\n                ', Math.round(this.calcDiscount(this.price, this.compare_at_price)), '% off\n              ')) : null)), _createElement('div', { 'className': 'product-item__reviews' }, [this.review_count ? _createElement.apply(this, [
                        'div',
                        {
                            'className': 'cm_review-stars',
                            'key': '17310'
                        },
                        _map([
                            0,
                            1,
                            2,
                            3,
                            4
                        ], repeatI1.bind(this)),
                        _createElement('span', { 'className': 'cm_review-count' }, '(', this.review_count, ')')
                    ]) : null])), this.out_of_stock ? _createElement('div', {
                    'className': 'product-item__badges fs-body-x-small',
                    'key': '2163'
                }, _createElement('div', { 'className': 'product-item__badge product-item__badge--sold-out fs-body-bold' }, 'Sold out')) : null, scopeProductId2.apply(this, [])), _createElement('div', { 'className': 'product-item__quick-add-container' })));
            }, { count: undefined })];
    }
    return _createElement('div', { 'className': 'cm_related-products container' }, _createElement('div', { 'className': 'section-header text-left cm_related-products-title-container' }, _createElement('h2', { 'className': 'cm_related-products-title' }, _translate(`related_items_title`))), _createElement.apply(this, [
        'div',
        { 'className': 'cm_related-products-list cmRepeater_items' },
        _map(this.items, repeatItems1.bind(this))
    ]));
}
        export const componentNames = []